<template>
  <div>
    <uploader
      :options="options"
      @file-added="onFileAdded"
      @file-success="onFileSuccess"
      @file-error="onFileError"
      @complete="onComplete"
      :fileStatusText="filsStatusText"
      ref="uploader"
    >
      <!-- <uploader-unsupport></uploader-unsupport> -->
      <!-- <uploader-drop>
    </uploader-drop> -->
      <uploader-drop v-if="drag" class="el-upload-dragger relative">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <uploader-btn class="w-full h-full !absolute opacity-0 top-0 left-0"></uploader-btn>
      </uploader-drop>
    </uploader>
  </div>
</template>

<script>
import Vue from 'vue'
import SparkMD5 from 'spark-md5'
import { FileApi } from '@wiz-api/file-management'
import uploader from 'vue-simple-uploader'
import { round } from 'lodash'

Vue.use(uploader)
const fileApi = new FileApi()

/* eslint-disable */

export default {
  name: 'uploadFile',
  props: {
    drag: {
      type: Boolean,
      default: true,
    },
    uploadText: {
      type: String,
      default: '上传文件',
    },
    FolderId: {
      type: String,
      default: '',
    },
    fileMaxsize: {
      type: Number || null,
      default: null, // 单位 M
    },
    fileAccept: {
      type: String,
      default: '',
    },
    // 单个文件上传
    singleFile: {
      type: Boolean,
      default: false,
    },
    // 文件上传数量
    maxFileCount: {
      type: Number || null,
      default: null,
    },
    // 文件列表
    fileList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    const _this = this
    return {
      fileInfo: null, // 合并后的文件信息
      // 用于替换组件原来的状态显示文字
      filsStatusText: {
        success: '成功',
        error: '失败',
        uploading: '上传中',
        paused: '暂停',
        waiting: '等待中',
      },
      // uploader 的主要配置
      options: {
        singleFile: this.singleFile, // 是否单文件上传
        chunkSize: 2 * 1024 * 1024, // 允许片段最大为2M，因为最后一块默认是可以大于等于这个值，但必须小于它的两倍。
        simultaneousUploads: 3, // 最大并发上传数
        uploadMethod: 'POST',
        testMethod: 'POST',
        forceChunkSize: true, // 是否强制所有的块都是小于等于chunkSize的值，默认为false
        headers: {
          Authorization: '',
        },
        testChunks: false,
        target: (val) => {
          return `${this.fileManagement}/api/file-management/files/chunk-upload/${val.uniqueIdentifer}/${val.chunkIndex}`
        }, // 目标上传 URL，若测试和上传接口不是同个路径，可以用函数模式
        permanentErrors: [404, 415, 500, 501, 413, 409, 403], //需进入错误回调函数中提示错误信息
        // 每次发起测试校验，所有分片都会进入这个回调
        checkChunkUploadedByResponse: function(chunk, message) {
          // 每次校验，chunk（片段）会不一样，但message（只有一个测试请求）一样
          let objMessage = JSON.parse(message)
          // 后端认为这个文件上传过，则直接跳过
          if (objMessage.skipUpload) return true

          // 若文件检测出现异常，则提示并返回false
          if (objMessage.error) {
            _this.$message.error(objMessage.message)
            return false
          }
          // 一些校验信息，需要用到的，可以绑定在chunk上
          chunk.xxx = objMessage.xxx // 可写可不写，看自己情况

          // chunk的offset就是分块后，该块片段在文件所有模块的位置
          return (objMessage.uploadedList || []).indexOf(chunk.offset + 1) >= 0
        },
        // 处理所有请求的参数
        processParams: async (params, file, chunk) => {
          if (params.chunkNumber === 1) {
            file.chunkIndex = file.chunkInitIndex
          } else {
            file.chunkIndex++
          }
          // file.chunkIndex = params.chunkNumber
          return params
        },
        processResponse: (res, cb) => {
          if (res) {
            const parseRes = JSON.parse(res)
            const progress = round(((parseRes.chunk + 1) / this.maxChunks) * 100)
            this.$emit('on-progress', progress >= 100 ? 99 : progress)
          }
          cb(null, res)
        },
      },
      maxChunks: 0,
    }
  },
  computed: {
    fileManagement() {
      const endpoints = Wiz.globalSettings?.api?.endpoints
      const defaultApi = endpoints ? endpoints.default : ''
      const fileApiModuleName = Wiz.globalSettings?.api?.modules['file-management']
      const fileDomain = endpoints ? endpoints[fileApiModuleName] : ''
      return fileDomain ? fileDomain : defaultApi
    },
  },
  methods: {
    fileRemove(index) {
      this.$refs.uploader.fileList.splice(index, 1)
      this.$refs.uploader.files.splice(index, 1)
      console.log(this.$refs.uploader.fileList)
    },
    onComplete() {},
    // 导入文件时
    onFileAdded(file) {
      console.log(file)
      if (this.maxFileCount && this.fileList?.length >= this.maxFileCount) {
        this.$message.warning(`最多只能上传${this.maxFileCount}个文件`)
        file.pause()
        file.cancel()
        return false
      }
      if (this.fileAccept) {
        const fileFormat = this.fileAccept.split(',').includes(
          file.name
            .split('.')
            .at(-1)
            .toLowerCase()
        )
        // 附件不限制文件格式
        if (!fileFormat) {
          this.$message.warning(`请上传指定格式的文件，${this.fileAccept}`)
          file.pause()
          file.cancel()
          return false
        }
      }
      if (this.fileMaxsize) {
        const isGreatThenMaxsize = file.size / 1024 / 1024 > this.fileMaxsize
        if (isGreatThenMaxsize) {
          this.$message.error(`文件大小超过限制，最大为${this.fileMaxsize}M`)
          file.pause()
          file.cancel()
          return false
        }
      }
      // 计算文件 MD5 并标记文件
      this.computeMD5(file)
      return true
    },
    // 上传失败
    onFileError(rootFile, file, res) {
      this.$message.error(JSON.parse(res).error)
    },
    // 取消文件上传
    onFileRemoved(file) {
      // 发起取消上传请求给后端
      //   this.$axios.cancelUploadFile({
      //     filename: file.name,
      //     identifier: file.uniqueIdentifer, // 文件标记
      //   })
    },
    // 所有片段上传成功后，进入文件上传成功回调
    async onFileSuccess(rootFile, file, res) {
      // 后端返回成功的字段，插件认为只要所有片段的上传请求都成功了就是上传成功了，而对于其他的错误它是无法处理的
      // 如果后端返回可以合并的字段则发起合并请求
      if (res) {
        const [err, res] = await fileApi.mergeFiles({
          body: {
            md5: file.uniqueIdentifer,
            fileName: file.name,
            folderId: '00000000-0000-0000-0000-000000000000',
            authLevel: 2,
          },
        })
        if (!err) {
          this.fileInfo = res[0]
          this.$emit('filesUploadComplete', this.fileInfo)
        } else {
          this.$emit('on-error')
        }
      } else {
        // 分片上传成功，但整个文件上传并未结束，不需要合并
      }
    },
    // 根据文件内容计算 MD5 并标记文件 file
    computeMD5(file) {
      let fileReader = new FileReader()
      let time = new Date().getTime()
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
      let currentChunk = 0
      const chunkSize = this.options.chunkSize
      let chunks = Math.ceil(file.size / chunkSize) // 总模块数
      let spark = new SparkMD5.ArrayBuffer()
      this.maxChunks = chunks

      file.pause() // 先暂停文件的上传过程

      loadNext() // 开始读取文件内容

      // FileReader 加载完成
      fileReader.onload = (e) => {
        // 插入读取的片段内容到 SparkMD5 中
        spark.append(e.target.result)

        // 按分片顺序读取，小于最后模块位置的就继续读取
        if (currentChunk < chunks) {
          currentChunk++
          loadNext()
        } else {
          // 所有文件分片内容读取完成，生成MD5
          let md5 = spark.end()
          // 在computeMD5Success中标记文件
          this.computeMD5Success(md5, file)
        }
      }
      // FileReader 加载失败
      fileReader.onerror = function() {
        this.error(`文件${file.name}读取出错，请检查该文件`)
        file.cancel()
      }

      // 分片读取文件内容函数
      function loadNext() {
        let start = currentChunk * chunkSize
        let end = start + chunkSize >= file.size ? file.size : start + chunkSize
        // fileReader 读取文件
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end))
      }
    },
    async computeMD5Success(md5, file) {
      file.uniqueIdentifer = md5 // 标记文件file
      // 通过md5获取当前文件的切片号
      const [err, res] = await fileApi.getMaxChunk(file.uniqueIdentifer)
      if (!err) {
        if (res >= 0) {
          file.chunkInitIndex = res
        } else {
          file.chunkInitIndex = 0
        }
      }
      file.resume() // 继续上传
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .uploader-drop {
  background-color: var(--contentBgColor);
}
::v-deep .uploader-btn {
  background-color: var(--contentBgColor);
  border: 1px dashed var(--lineBorderColor);
  border-radius: 6px;
  &:hover {
    border-color: var(--uploadHoverColor);
  }
}
</style>
